import React from 'react';

import { type ObjectData } from './types';

export const getObjectSizes: (object: ObjectData) => {
	label: string;
	element: React.JSX.Element;
	code: string;
}[] = (
	object: ObjectData,
): {
	label: string;
	element: React.JSX.Element;
	code: string;
}[] => [
	{
		label: 'Small (12px)',
		element: <object.component label="" size="small" />,
		code: `<${object.componentName} label="" size="small" />`,
	},
	{
		label: 'Medium (16px)',
		element: <object.component label="" size="medium" />,
		code: `<${object.componentName} label="" size="medium" />`,
	},
];
